import * as Yup from 'yup';

export type ChequeNoteType = {
  chequeGiroId: string | null;
  bankAccountId: string | null;
  referenceNumber: string | null;
  issuedAt: Date;
  availableAt: Date;
  expiredAt: Date;
};

export type PaymentItemType = {
  total: number;
  paidAmount: number;

  amount: number;
  tax: number;
  discount: number;
  fee: number;

  isCheck: boolean;

  purchaseId: string;
  purchaseRefId: string;
  invoiceNumber: string;
  dueDate: Date | null;
};

export type FormType = {
  transactionAt: Date;
  tempTransactionAt: Date;
  needApproval: boolean;
  // externalId: string;
  refId?: string;
  number: string;
  agentId: string | null;
  description: string;
  paymentItems: PaymentItemType[];
  paymentMethodId: string | null;
  paymentMethod: string | undefined;
  chequeNote: ChequeNoteType | null;
  paymentableId: string | null;
};

export const accountPayableSchema = () =>
  Yup.object().shape({
    transactionAt: Yup.date().nullable().required(),
    // externalId: Yup.string().required(),
    refId: Yup.string(),
    agentId: Yup.string().nullable().required(),
    description: Yup.string().nullable(),
    paymentMethodId: Yup.string().nullable().required(),
    paymentMethod: Yup.string(), //Validation
    chequeNote: Yup.object({
      purchaseRefId: Yup.string().nullable(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      tax: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      discount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      fee: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0),
      purchaseId: Yup.string().nullable(),
      bankAccountId: Yup.string().nullable(),
    }).nullable(),
    paymentItems: Yup.array().of(
      Yup.object({
        amount: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
        tax: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
        discount: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
        fee: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .min(0)
          .required(),
      }),
    ),
  });
